import { render, staticRenderFns } from "./ViewAdminCampaign.vue?vue&type=template&id=fa3834e4&scoped=true"
import script from "./ViewAdminCampaign.vue?vue&type=script&lang=ts"
export * from "./ViewAdminCampaign.vue?vue&type=script&lang=ts"
import style0 from "./ViewAdminCampaign.vue?vue&type=style&index=0&id=fa3834e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3834e4",
  null
  
)

export default component.exports